import { useMutation } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export type UpsertFileParams = {
  fileName: string;
  fileType: string;
  fileChecksum: string;
  fileSize: number;
  id?: string;
};

type ActiveStorageBlob = {
  url: string;
  signedId: string;
  headers: Record<string, string>;
};

export type UpsertFileResponse = {
  activeStorageBlob: ActiveStorageBlob;
  assetId: string;
};

const upsertFile = (upsertFileParams: UpsertFileParams): Promise<UpsertFileResponse> =>
  FetchPromise.post(`${CMS_API_ROOT_URL}/file`, upsertFileParams);

export const useUpsertFile = (mutationOptions?: { retry: number }) => useMutation(upsertFile, mutationOptions);
